import React from 'react'

import Back1 from "../../../../assets/images/back1.jpg"
import Back2 from "../../../../assets/images/back2.jpg"

import Planet7 from "../../../../assets/images/planet7.png"
import Astroid8 from "../../../../assets/images/astroid8.png"

import "./Ultra.scss"

const Ultra = () => {
    return (
        <>
            <div className="ultra_container">
                <div className="box">
                    <img src={Planet7} alt="ERROR" className='planet7' />
                    <img src={Astroid8} alt="ERROR" className='astroid8' />
                    <div className="backgrounds">
                        <div className="heading"> Ultra detailed backgrounds </div>
                        <div className="back">
                            <img src={Back1} alt="ERROR" />
                            <img src={Back2} alt="ERROR" />
                        </div>
                    </div>
                    <div className="slid">
                    
                    </div>
                </div>
            </div>
        </>
    )
}

export default Ultra
